import artists from './artists.json'

const ArtiestComponent = ({ name, img }: { name: string, img: string }) => {
    return <div className='flex flex-col gap-4 items-center justify-center flex-1 self-start '>
        <div className=' w-[120px] h-[120px] rounded-full self-start '>
            <img alt={name} className='w-full h-full rounded-full overflow-hidden object-cover' src={"https://passticketsstorage.blob.core.windows.net/images/f1-2025" + img} />
        </div>
        <span className='text-[16px] text-white font-bold uppercase flex text-center'>{name}</span>
    </div>
}

const RenderArtiest = () => {
    const renderedArtiest = artists.map((item) => <ArtiestComponent  {...item} key={item?.name} />)
    return <div className="flex flex-row  gap-10">
        {renderedArtiest}
    </div>
}

export default RenderArtiest;